import {analyticsCustomersSlice} from './analyticsCustomersSlice';

export default analyticsCustomersSlice.reducer;
